module.exports = __webpack_public_path__ + "img/main_top.b4092c31.png";